/*@ngInject*/
const UICalendarAutoCloseDirective = function ($timeout, $document) {

    let linkFunction = function ($scope, $elm, $attrs) {

        let element = $($elm),
            targetElement = $($attrs['uiCalendarAutoClose']),
            bodySourceDom = $document[0].body;

        function handleClick(event) {
            let target = $(event.target),
                isChildElement = element.find(target).length;

            if (!isChildElement) {
                closeElement();
            }
        }

        function closeElement() {
            $scope.$ctrl.popupOpen = false;
            $timeout(function () {
            }, 0);
        }

        targetElement.on('scroll', closeElement);
        /*
         * For any click in the window, call handleClick to check
         * if the click is outside the popup. Use event capturing
         * (i.e., the "true" argument to bodySourceDom.addEventListener)
         * so that handleClick is called before Angular processes
         * the click. For example, if the user clicks on the "month"
         * button in the "day" layout, Angular will switch to the "month"
         * layout, and so the "month" button in the "day" layout
         * will no longer be a child of element. Similarly for clicking
         * on the "year" button in the "month" layout.
         */
        bodySourceDom.addEventListener('click', handleClick, true);

        $elm.on('$destroy', function () {
            targetElement.off('scroll', closeElement);
            bodySourceDom.removeEventListener('click', handleClick, true);
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiCalendarAutoClose', UICalendarAutoCloseDirective);
